/** Builds a /contact URL carrying the interest + source for tracking. */
export interface ContactLinkOptions {
  /** Pre-selected course/service, e.g. 'program:rebuild' or 'service:mobility'. */
  interest?: string;
  /** Where the click came from, e.g. 'hero', 'header', 'programs', 'method'. */
  from?: string;
}

export function contactHref(opts: ContactLinkOptions = {}): string {
  const params = new URLSearchParams();
  if (opts.interest) params.set('interest', opts.interest);
  if (opts.from) params.set('from', opts.from);
  const qs = params.toString();
  return qs ? `/contact?${qs}` : '/contact';
}
